import { render } from "./ChatSendMessagePropsCmp.vue?vue&type=template&id=b2f866ba"
import script from "./ChatSendMessagePropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatSendMessagePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__